// icon:bx-support | Boxicons https://boxicons.com/ | Atisa
import type React from "react";
import type { SVGProps } from "react";

interface CommentIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

export function CommentIcon(props: CommentIconProps): React.ReactNode {
  const { size = 20, color = "black", ...rest } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Comment</title>
      <g clipPath="url(#clip0_403_3066)">
        <path
          d="M23.9998 11.2472C23.8552 8.90722 23.029 6.66071 21.623 4.78462C20.2171 2.90854 18.2928 1.48489 16.0875 0.689192C13.8823 -0.106505 11.4923 -0.239469 9.21239 0.306693C6.93245 0.852855 4.86217 2.05427 3.25678 3.76282C1.65139 5.47137 0.581072 7.61236 0.177774 9.92186C-0.225525 12.2314 0.0558282 14.6084 0.987148 16.7599C1.91847 18.9114 3.45904 20.7434 5.41894 22.0299C7.37884 23.3165 9.67239 24.0014 12.0168 24.0002H18.9998C20.3255 23.9989 21.5965 23.4717 22.5339 22.5343C23.4713 21.5969 23.9985 20.3259 23.9998 19.0002V11.2472ZM21.9998 19.0002C21.9998 19.7958 21.6838 20.5589 21.1212 21.1215C20.5585 21.6841 19.7955 22.0002 18.9998 22.0002H12.0168C10.6058 21.9996 9.21068 21.7015 7.92253 21.1255C6.63438 20.5495 5.48211 19.7084 4.54083 18.6572C3.59501 17.6065 2.88476 16.3657 2.45773 15.018C2.03069 13.6703 1.89673 12.2469 2.06483 10.8432C2.33027 8.62914 3.32502 6.56639 4.89227 4.98012C6.45953 3.39386 8.51013 2.37431 10.7208 2.0822C11.1521 2.02815 11.5862 2.00076 12.0208 2.0002C14.3513 1.99384 16.6096 2.8081 18.3998 4.3002C19.4454 5.16914 20.3035 6.24135 20.9224 7.45183C21.5412 8.6623 21.9077 9.98584 21.9998 11.3422V19.0002Z"
          fill={color}
        />
        <path
          d="M7.99985 8.99987H11.9998C12.2651 8.99987 12.5194 8.89452 12.707 8.70698C12.8945 8.51945 12.9998 8.26509 12.9998 7.99988C12.9998 7.73466 12.8945 7.48031 12.707 7.29277C12.5194 7.10523 12.2651 6.99988 11.9998 6.99988H7.99985C7.73463 6.99988 7.48028 7.10523 7.29274 7.29277C7.1052 7.48031 6.99985 7.73466 6.99985 7.99988C6.99985 8.26509 7.1052 8.51945 7.29274 8.70698C7.48028 8.89452 7.73463 8.99987 7.99985 8.99987Z"
          fill={color}
        />
        <path
          d="M15.9998 11.0001H7.99985C7.73463 11.0001 7.48028 11.1055 7.29274 11.293C7.1052 11.4806 6.99985 11.7349 6.99985 12.0001C6.99985 12.2653 7.1052 12.5197 7.29274 12.7072C7.48028 12.8948 7.73463 13.0001 7.99985 13.0001H15.9998C16.2651 13.0001 16.5194 12.8948 16.707 12.7072C16.8945 12.5197 16.9998 12.2653 16.9998 12.0001C16.9998 11.7349 16.8945 11.4806 16.707 11.293C16.5194 11.1055 16.2651 11.0001 15.9998 11.0001Z"
          fill={color}
        />
        <path
          d="M15.9998 15H7.99985C7.73463 15 7.48028 15.1054 7.29274 15.2929C7.1052 15.4804 6.99985 15.7348 6.99985 16C6.99985 16.2652 7.1052 16.5196 7.29274 16.7071C7.48028 16.8947 7.73463 17 7.99985 17H15.9998C16.2651 17 16.5194 16.8947 16.707 16.7071C16.8945 16.5196 16.9998 16.2652 16.9998 16C16.9998 15.7348 16.8945 15.4804 16.707 15.2929C16.5194 15.1054 16.2651 15 15.9998 15Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_403_3066">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
